import { CurrencyInfo, ISOCurrencyCode } from '@policyfly/protobuf'
import { RoundingMode } from '@policyfly/protobuf/pfschema'
import { formatValue as utilsFormatValue } from '@policyfly/utils/formatter'

/**
 * See {@link utilsFormatValue formatValue}.
 * Provides default settings for use with the generic util.
 */
export function formatValue (v: Parameters<typeof utilsFormatValue>[1], formatter: Parameters<typeof utilsFormatValue>[2]): ReturnType<typeof utilsFormatValue> {
  try {
    return utilsFormatValue(
      {
        locale: () => 'en-US',
        getEffectiveDate: () => null,
        cancellationRequests: false,
        decimals: false,
        roundingMode: RoundingMode.ROUNDING_MODE_HALF_UP,
        getCurrencyInfo: () => CurrencyInfo.create({ currency: ISOCurrencyCode.ISO_CURRENCY_CODE_USD }),
        getAttachmentMetadata: (id: string) => undefined,
      },
      v,
      formatter,
    )
  } catch (err) {
    console.error(err)
    return ''
  }
}
